import {get} from 'lodash';
import {UserGroup} from '@deviceinsight/ng-ui-api-client';
import {ReactableColumnDef} from '@deviceinsight/ng-ui-components';

export const getUserGroupColumnDefinitions = (defaultColumnDefinitions: Array<ReactableColumnDef<UserGroup>>) => {
	return [
		defaultColumnDefinitions[0],
		{
			name: 'subtenantName',
			label: {
				id: 'properties.subtenantName',
				defaultValue: 'Customer Name'
			},
			width: '300px',
			sortable: false,
			render: (userGroup: UserGroup) => get(userGroup, 'properties.subtenantName')
		},
		...defaultColumnDefinitions.slice(1)
	];
};
